import { useState, FormEvent } from 'react';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9qseq7nahb7382oves0';

export default function Contact() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      return;
    }

    const email = formData.get('email') as string;
    const name = formData.get('name') as string;
    const message = formData.get('message') as string;

    if (!email || !name || !message) {
      setFormStatus('error');
      setFormError('Tüm zorunlu alanları doldur. Eksik bırakma.');
      return;
    }

    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'phone_alt') body.append(key, value as string);
    });

    try {
      const response = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormError('');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || 'Bir hata oluştu. Tekrar dene.';
        if (serverMsg.toLowerCase().includes('spam') || serverMsg.includes('form data is spam')) {
          setFormStatus('error');
          setFormError('Gönderim reddedildi. Lütfen tekrar dene.');
        } else {
          setFormStatus('error');
          setFormError(serverMsg);
        }
      }
    } catch {
      setFormStatus('error');
      setFormError('Bağlantı hatası. İnternetini kontrol edip tekrar dene.');
    }
  };

  return (
    <section id="contact" className="section-padding bg-background-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Contact Info */}
          <div>
            <p className="text-primary-500 font-bold text-sm tracking-widest uppercase mb-2">
              BURADAYIZ
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter mb-8 md:mb-10">
              HADİ KONUŞALIM
            </h2>

            <div className="space-y-4">
              <div className="glass-card-hover rounded-2xl p-5 flex items-center gap-4 group cursor-pointer">
                <div className="w-12 h-12 bg-background-200 rounded-xl flex items-center justify-center group-hover:bg-primary-500/10 transition-colors">
                  <i className="ri-phone-line text-xl text-primary-500" />
                </div>
                <p className="text-foreground-200 text-base font-medium">+90 555 710 1968</p>
              </div>

              <div className="glass-card-hover rounded-2xl p-5 flex items-center gap-4 group cursor-pointer">
                <div className="w-12 h-12 bg-background-200 rounded-xl flex items-center justify-center group-hover:bg-primary-500/10 transition-colors">
                  <i className="ri-mail-line text-xl text-primary-500" />
                </div>
                <p className="text-foreground-200 text-base font-medium">info@biffdigital.com</p>
              </div>

              <div className="glass-card-hover rounded-2xl p-5 flex items-center gap-4 group cursor-pointer">
                <div className="w-12 h-12 bg-background-200 rounded-xl flex items-center justify-center group-hover:bg-primary-500/10 transition-colors">
                  <i className="ri-map-pin-line text-xl text-primary-500" />
                </div>
                <p className="text-foreground-200 text-base leading-relaxed font-medium">
                  Söğütözü Cad. No: 2 Koç Kuleleri C Blok 17 Çankaya/Ankara
                </p>
              </div>
            </div>

            <div className="glass-card rounded-2xl p-6 mt-6">
              <h3 className="text-lg font-bold text-foreground-50 mb-4">Çalışma Saatleri</h3>
              <div className="space-y-2 text-sm text-foreground-400">
                <p>Pazartesi - Cuma: 09:00 - 18:00</p>
                <p>Cumartesi, Pazar: Kapalı</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 tracking-tighter mb-6 md:mb-8">
              MESAJ AT
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form id="contact-form">
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-bold text-foreground-200 mb-2 uppercase tracking-wider">
                    Ad Soyad *
                  </label>
                  <input
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 rounded-xl bg-background-100 border border-white/10 text-foreground-50 placeholder-foreground-600 focus:outline-none focus:border-primary-500 transition-colors"
                    placeholder="Adın ne?"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-bold text-foreground-200 mb-2 uppercase tracking-wider">
                    E-posta *
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-3 rounded-xl bg-background-100 border border-white/10 text-foreground-50 placeholder-foreground-600 focus:outline-none focus:border-primary-500 transition-colors"
                    placeholder="ornek@email.com"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-bold text-foreground-200 mb-2 uppercase tracking-wider">
                  Konu *
                </label>
                <input
                  id="subject"
                  name="subject"
                  required
                  className="w-full px-4 py-3 rounded-xl bg-background-100 border border-white/10 text-foreground-50 placeholder-foreground-600 focus:outline-none focus:border-primary-500 transition-colors"
                  placeholder="Ne hakkında?"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-bold text-foreground-200 mb-2 uppercase tracking-wider">
                  Mesaj *
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-3 rounded-xl bg-background-100 border border-white/10 text-foreground-50 placeholder-foreground-600 focus:outline-none focus:border-primary-500 transition-colors resize-none"
                  placeholder="Anlat bakalım..."
                />
                <p className="text-xs text-foreground-600 mt-1">Maksimum 500 karakter</p>
              </div>

              <button type="submit" className="btn-primary w-full md:w-auto justify-center font-bold uppercase tracking-wider">
                Gönder
                <i className="ri-send-plane-line" />
              </button>

              {formStatus === 'success' && (
                <div className="p-4 rounded-xl bg-green-500/10 border border-green-500/20 text-green-400 text-sm font-medium">
                  Aldık! En kısa sürede dönüş yapacağız.
                </div>
              )}

              {formStatus === 'error' && (
                <div className="p-4 rounded-xl bg-primary-500/10 border border-primary-500/20 text-primary-400 text-sm font-medium">
                  {formError || 'Bir hata oluştu. Tekrar dene.'}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}